<template>
  <section
    v-if="status.translation"
    class="StatusTranslation"
    :lang="language"
  >
    <p class="status-translation-source">
      <span class="faint">{{ source }}</span>
      <button
        class="button-unstyled -link"
        type="button"
        @click="hide"
      >
        {{ $t('status.hide_translation') }}
      </button>
    </p>
    <button
      v-if="folded"
      class="btn button-default"
      type="button"
      @click="unfolded = true"
    >
      {{ $t('status.show_translation') }}
    </button>
    <RichContent
      v-else
      class="status-translation-content"
      :html="status.translation.content"
      :emoji="status.emojis"
    />
  </section>
</template>

<script>
import { useStatusesStore } from 'src/stores/statuses.js'

// A post's translation, under the post, with where it came from.
export default {
  props: {
    status: { type: Object, required: true },
  },
  data: () => ({ unfolded: false }),
  computed: {
    // a post behind a content warning keeps its translation folded too
    folded() {
      return !!this.status.summary && !this.unfolded
    },
    language() {
      return this.status.translation?.lang ?? undefined
    },
    source() {
      const { detected_source_language: from, provider } =
        this.status.translation
      const names = new Intl.DisplayNames([this.$i18n?.locale ?? 'en', 'en'], {
        type: 'language',
      })
      return from
        ? this.$t('status.translated_from', {
            language: names.of(from),
            provider,
          })
        : this.$t('status.translated_by', { provider })
    },
  },
  methods: {
    hide() {
      useStatusesStore().clearTranslation(this.status.id)
    },
  },
}
</script>

<style lang="scss">
.StatusTranslation {
  margin: 0.6em 0;
  padding: 0.5em 0.7em;
  border-inline-start: 3px solid var(--border);

  .status-translation-source {
    margin: 0 0 0.3em;
    font-size: var(--fs-sm);
    display: flex;
    flex-wrap: wrap;
    gap: 0.3em 0.8em;
  }
}
</style>
